export default {
  init() {
    // JavaScript to be fired on all pages
    const header = document.querySelector('header.banner')
    const bodyWrapper = document.querySelector('header.banner + .wrap main > *')
    let headerHeight = header.offsetHeight
    bodyWrapper.style.paddingTop = headerHeight + 'px'

    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    })

    $('#menu-primary-navigation-1 .menu-item-has-children').on('click', function() {
      // slide toggle the child that has the class sub-menu
      $(this).children('.sub-menu').slideToggle();
      $('#menu-primary-navigation-1 .menu-item-has-children').removeClass('open');
      $(this).addClass('open');
    })

    $('.mobile-toggle').on('click', function() { 
      $('.nav-mobile').addClass('open');
      $('.wrap').addClass('dim')
      $('html, body').addClass('no-scroll')
    })

    $('.mobile-close').on('click', function() { 
      $('.nav-mobile').removeClass('open');
      $('.wrap').removeClass('dim')
      $('html, body').removeClass('no-scroll')
    })

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
